import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

interface RegularInputProps {
  value: string | undefined;
  onChange(text: string): void;
  catchEnter?(isEnter: boolean): any;
  inputBlurText?(): void;
  label: string;
  fieldName?: string;
  maxLength?: number | undefined;
}

const RegularInput: FC<RegularInputProps> = (props) => {
  const { value = "", onChange, catchEnter, inputBlurText, label, fieldName, maxLength } = props;
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.value);
  };

  const catchEnterOnKeyUp = (event: any) => {
    if (event.key === "Enter" && catchEnter) {
      catchEnter(true);
    }
  }

  const changeFocus = () => {
    setIsFocused(!isFocused);
    if (inputBlurText)
      inputBlurText();
  };


  return (
    <div className="regular_input">
    {label && <p>{`${label}:`}</p>}
      <input
        type="text"
        value={value}
        placeholder={t("enterYourText") + " " + `${fieldName}`}
        onChange={handleOnChange}
        onKeyUp={catchEnterOnKeyUp}
        onBlur={changeFocus}
        maxLength={maxLength ? maxLength : 20}
      />
  </div>
  );
};

export default RegularInput;
